import useForm, { SubmitPromise, UseFormResult } from "@saleor/hooks/useForm";
import React from "react";

export enum FormMethod {
  GET = "GET",
  POST = "POST"
}

export interface FormProps<T> {
  children: (props: UseFormResult<T>) => React.ReactNode;
  confirmLeave?: boolean;
  initial?: T;
  resetOnSubmit?: boolean;
  onSubmit?: (data: T) => SubmitPromise | any;
  noAutocomplete?: boolean;
  method?: FormMethod;
}

function Form<T>(props: FormProps<T>) {
  const {
    children,
    initial,
    resetOnSubmit,
    onSubmit,
    noAutocomplete,
    method
  } = props;
  const renderProps = useForm(initial, onSubmit);

  function handleSubmit(event?: React.FormEvent<any>, cb?: () => void) {
    const { reset, submit } = renderProps;

    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }

    if (cb) {
      cb();
    }

    if (resetOnSubmit) {
      reset();
    }

    submit();
  }

  const formMethod = method ?? FormMethod.POST;

  return noAutocomplete ? (
    <form onSubmit={handleSubmit} autoComplete="off" method={formMethod}>
      {children(renderProps)}
    </form>
  ) : (
    <form onSubmit={handleSubmit} method={formMethod}>
      {children(renderProps)}
    </form>
  );
}
Form.displayName = "Form";

export default Form;
